export default __webpack_public_path__ + "static/media/MarcaBGMobile.7bb9002c.jpg";